import { actions } from './../../actions/actionsWrapper';
import { put } from 'redux-saga/effects';
import { thangDiemApi } from './../../../api/thangDiemApi';
import { call } from 'redux-saga/effects';
import { IBaseResponeModel } from './../../../models/response/base-response';
import { eThangDiemActionTypeIds } from './../../action-types/so-diem/IThangDiemActions';
import { takeLatest } from 'redux-saga/effects';
export function* thangDiemSaga(): any {
    yield takeLatest(eThangDiemActionTypeIds.LOAD_START, loadWorker);
}
function* loadWorker(): any {
    const res: IBaseResponeModel = yield call([thangDiemApi, thangDiemApi.selectAll])
    if (res.is_success) {
        yield put(actions.soDiem.thangDiem.loadSuccess(res.data))
    } else {
        yield put(actions.soDiem.thangDiem.loadError(res.message || "Không tải được thang điểm"))

    }
}